// extracted by mini-css-extract-plugin
export default {"container":"climaHoy_container__x8F47","hora":"climaHoy_hora__NB8B6","adicional":"climaHoy_adicional__3-j-R","temperatura":"climaHoy_temperatura__azPED","img":"climaHoy_img__ktThL"};